import rjs from '../../assets/stacklogo/reactjs.svg'

export default function Rjs(){
    return(
        <img src={rjs} alt="" srcset="" />
    )
}